import React from "react";
import {
  Box,
  Button,
  Collapse,
  FormControl,
  FormLabel,
  HStack,
  Icon,
  Input,
  Select,
  SimpleGrid,
  useColorModeValue,
} from "@chakra-ui/react";
import { BsFilter } from "react-icons/bs";
import TradeFilterChips from "../summary/TradeFilterChips";

/**
 * PnlCalendar's filter bar mirrors Summary's TradeFilters but exposes only
 * trade_type / security_type / trade_direction / ticker (no dates, no
 * time frame, no tag). Filter state remains in PnlCalendar so the
 * dispatch-bound handlers keep their direct read access.
 */
const PnlCalendarFilters = ({
  filters,
  onRemoveFilter,
  labelMap,
  toggleFilter,
  onToggleFilter,
  filter_trade_type,
  setFilterTradeType,
  filter_security_type,
  setFilterSecurityType,
  filter_trade_direction,
  setFilterTradeDirection,
  searchTickerValue,
  selectedTickerValue,
  onTickerInputChange,
  onTickerInputClick,
  isDropdownOpen,
  isLoading,
  searchTickerResultItems,
  onSubmit,
  onClear,
}) => {
  const filterPanelBg = useColorModeValue("white", "gray.700");
  const searchDropdownClass = useColorModeValue(
    "search-dropdown",
    "search-dropdown search-dropdown-dark"
  );

  return (
    <Box position="relative" zIndex={2}>
      <HStack spacing={3} flexWrap="wrap">
        <Button
          size="sm"
          variant="ghost"
          colorScheme="gray"
          leftIcon={<Icon as={BsFilter} />}
          onClick={onToggleFilter}
          borderRadius="md"
        >
          Filters
        </Button>
        <TradeFilterChips
          filters={filters}
          onRemoveFilter={onRemoveFilter}
          labelMap={labelMap}
        />
      </HStack>

      <Collapse
        in={toggleFilter}
        animateOpacity
        style={{ overflow: toggleFilter ? "visible" : "hidden" }}
      >
        <Box mt={3} p={4} bg={filterPanelBg} rounded="lg" boxShadow="sm">
          <SimpleGrid columns={{ base: 2, md: 4 }} spacing={3}>
            <FormControl>
              <FormLabel fontSize="xs" mb={1}>Trade Type</FormLabel>
              <Select
                size="sm"
                placeholder="All"
                value={filter_trade_type}
                onChange={(e) => setFilterTradeType(e.target.value)}
              >
                <option>Swing Trade</option>
                <option>Day Trade</option>
              </Select>
            </FormControl>
            <FormControl>
              <FormLabel fontSize="xs" mb={1}>Security Type</FormLabel>
              <Select
                size="sm"
                placeholder="All"
                value={filter_security_type}
                onChange={(e) => setFilterSecurityType(e.target.value)}
              >
                <option>Options</option>
                <option>Shares</option>
              </Select>
            </FormControl>
            <FormControl>
              <FormLabel fontSize="xs" mb={1}>Direction</FormLabel>
              <Select
                size="sm"
                placeholder="All"
                value={filter_trade_direction}
                onChange={(e) => setFilterTradeDirection(e.target.value)}
              >
                <option>Long</option>
                <option>Short</option>
                <option>Call</option>
                <option>Put</option>
              </Select>
            </FormControl>
            <FormControl>
              <FormLabel fontSize="xs" mb={1}>Ticker</FormLabel>
              <div className="ticker-search">
                <Input
                  size="sm"
                  type="name"
                  placeholder="Enter Ticker"
                  value={selectedTickerValue ? selectedTickerValue : searchTickerValue}
                  onChange={onTickerInputChange}
                  onClick={onTickerInputClick}
                />
                {isDropdownOpen && (
                  <ul className={searchDropdownClass}>
                    {isLoading ? <div>Loading...</div> : searchTickerResultItems}
                  </ul>
                )}
              </div>
            </FormControl>
          </SimpleGrid>
          <HStack mt={3} spacing={2}>
            <Button size="sm" colorScheme="blue" onClick={onSubmit}>
              Apply
            </Button>
            <Button
              size="sm"
              variant="outline"
              colorScheme="gray"
              onClick={onClear}
            >
              Clear
            </Button>
          </HStack>
        </Box>
      </Collapse>
    </Box>
  );
};

export default PnlCalendarFilters;
